module.exports = __webpack_public_path__ + "static/whitecellular-d72ddc4f7b8b70ada62d5244a352aa8f.png";